export default {
    "REGION": "eu-west-2",
    "USER_POOL_ID": "eu-west-2_FlDrUqcm7",
    "USER_POOL_APP_CLIENT_ID": "3584a6h0bf4q0d2ceanj9em239"
};
